import React, { useState } from "react";
import Colors from "../../theme/colors.json";
import { makeStyles } from "@mui/styles";
import {
  Button,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  CONFIRMATION_CONTENT,
  CONFIRMATION_TITLE,
  DECISION_MENUITEMS,
  USER_GROUPS,
} from "../../constants/constants";
import FileUpload from "../../components/FileUpload";
import { useFormik, getIn } from "formik";
import * as Yup from "yup";
import { POLICY_DOCUMENT_DETAILS_CONSTANTS } from "./FormConstants";
import DocumentUpload from "./DocumentUpload";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  policyDocumentDetailsSection: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  policyDocumentDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1.5vw",
    background: Colors.WHITE_BACKGROUND,
    padding: "2.5% 2.5% 2.5% 2.5%",
    borderRadius: "0.6rem",
    fontSize: theme.fontSizes.SMALL,
    width: "95%",
  },
  policyDocumentDetailsHeadingSection: {
    display: "flex",
    justifyContent: "flex-start",
    width: "95%",
    marginBottom: "0.5%",
    borderRadius: "0.5vw",
  },
  policyDocumentDetailsHeading: {
    color: theme.palette.secondary.main,
    fontSize: theme.fontSizes.MEDIUM,
    fontWeight: 600,
  },
  documentsContainer: {
    borderRadius: "1vw",
    boxShadow: `inset -2px -2px 4px ${theme.palette.primary.main}50,
    inset 2px 2px 4px ${theme.palette.primary.main}25,
    inset 5px 5px 10px ${theme.palette.primary.main}50,
    inset -5px -5px 10px ${theme.palette.primary.main}50`,
    width: "95%",
  },
  documentsSection: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    rowGap: 25,
    padding: "2% 2.5% 2% 2.5%",
    justifyContent: "space-between",
  },
  reportsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "95%",
  },
  formFlexRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "3%",
    flexWrap: "wrap",
    width: "95%",
  },
  fieldFlexColumn: {
    flex: " 0 0 48%",
    display: "flex",
    flexDirection: "column",
    gap: "3%",
  },
  policyDocumentDetailsFileUploader: {
    flex: " 0 0 48%",
  },
  commonBtnStyles: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },
  selectField: {
    fontSize: theme.fontSizes.SMALL,
    // height: "1.875rem !important",
  },
  textField: {
    fontSize: theme.fontSizes.SMALL,
    // height: "1.875rem !important",
  },
  validationContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "6%",
  },
}));

function PolicyDocumentDetails({ formPolicyDocumentDetails }) {
  const classes = useStyles();
  const { userGroup } = useSelector((state: any) => ({
    userGroup: state.userGroup,
  }));

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const handleYes = () => {
    setConfirmDialogOpen(false);
    formPolicyDocumentDetails.setFieldValue("validation", true, true);
  };

  const handleNo = () => {
    setConfirmDialogOpen(false);
  };

  return (
    <>
      <ConfirmationDialog
        open={confirmDialogOpen}
        setOpen={setConfirmDialogOpen}
        title={CONFIRMATION_TITLE}
        content={CONFIRMATION_CONTENT}
        handleYes={handleYes}
        handleNo={handleNo}
      />

      <div className={classes.policyDocumentDetailsSection}>
        <div className={classes.policyDocumentDetailsHeadingSection}>
          <div className={classes.policyDocumentDetailsHeading}>
            Policy Document details
          </div>
        </div>
        <div className={classes.policyDocumentDetailsContainer}>
          <div className={classes.formFlexRow}>
            <div className={classes.fieldFlexColumn}>
              <label>Policy Number</label>
              <TextField
                fullWidth
                size="small"
                name="policyNumber"
                value={formPolicyDocumentDetails?.values?.policyNumber}
                onChange={formPolicyDocumentDetails.handleChange}
                helperText={
                  formPolicyDocumentDetails.touched.policyNumber &&
                  formPolicyDocumentDetails.errors.policyNumber
                }
                error={
                  formPolicyDocumentDetails.touched.policyNumber &&
                  Boolean(formPolicyDocumentDetails.errors.policyNumber)
                }
                disabled={
                  formPolicyDocumentDetails?.values?.validation === true
                    ? true
                    : false
                }
                InputProps={{
                  className: classes.textField,
                }}
              />
            </div>
            <div className={classes.fieldFlexColumn}>
              <label>Is policy throughly reviewed</label>
              <Select
                className={classes.selectField}
                size="small"
                fullWidth
                name="isPolicyThroughlyReviewed"
                value={
                  formPolicyDocumentDetails?.values?.isPolicyThroughlyReviewed
                }
                onChange={(e) =>
                  formPolicyDocumentDetails.setFieldValue(
                    "isPolicyThroughlyReviewed",
                    e.target.value,
                    true
                  )
                }
                error={
                  formPolicyDocumentDetails.touched.isPolicyThroughlyReviewed &&
                  Boolean(
                    formPolicyDocumentDetails.errors.isPolicyThroughlyReviewed
                  )
                }
                disabled={
                  formPolicyDocumentDetails?.values?.validation === true
                    ? true
                    : false
                }
              >
                {DECISION_MENUITEMS.map((item) => {
                  return <MenuItem value={item.value}>{item.title}</MenuItem>;
                })}
              </Select>
              <FormHelperText className="formikFieldsErrorColor">
                {formPolicyDocumentDetails.touched.isPolicyThroughlyReviewed &&
                  formPolicyDocumentDetails.errors.isPolicyThroughlyReviewed}
              </FormHelperText>
            </div>
          </div>
          <div className={classes.validationContainer}>
            <Button
              className={classes.commonBtnStyles}
              color="primary"
              size="small"
              variant="outlined"
              onClick={() => setConfirmDialogOpen(true)}
              disabled={
                formPolicyDocumentDetails?.values?.validation === true
                  ? true
                  : false
              }
            >
              Validation
            </Button>
            {userGroup === USER_GROUPS.ADMIN ? (
              <Button
                className={classes.commonBtnStyles}
                onClick={() =>
                  formPolicyDocumentDetails.setFieldValue(
                    "validation",
                    false,
                    true
                  )
                }
                variant="outlined"
                size="small"
                disabled={
                  formPolicyDocumentDetails?.values?.validation === true
                    ? false
                    : true
                }
              >
                Revalidation
              </Button>
            ) : null}
          </div>
          <div className={classes.documentsContainer}>
            <div className={classes.documentsSection}>
              <div className={classes.policyDocumentDetailsFileUploader}>
                <DocumentUpload
                  formOne={formPolicyDocumentDetails}
                  field="policyDocument"
                  title={"Policy Document"}
                />
              </div>

              <div className={classes.policyDocumentDetailsFileUploader}>
                <DocumentUpload
                  formOne={formPolicyDocumentDetails}
                  field="finalRfq"
                  title={"Final RFQ"}
                />
              </div>

              <div className={classes.policyDocumentDetailsFileUploader}>
                <DocumentUpload
                  formOne={formPolicyDocumentDetails}
                  field="finalQcr"
                  title={"Final QCR"}
                />
              </div>

              <div className={classes.policyDocumentDetailsFileUploader}>
                <DocumentUpload
                  formOne={formPolicyDocumentDetails}
                  field="mandateCopy"
                  title={"Mandate Copy"}
                />
              </div>
            </div>
          </div>
          {/* <div className={classes.reportsContainer}>
            <Button color="primary" variant="contained" size="small">
              SEND TROVITY's CONCISE REPORT
            </Button>
            <Button color="primary" variant="contained" size="small">
              SEND DOCUMENT ALONG WITH POLICY DOCUMENT
            </Button>
            <Button color="primary" variant="contained" size="small">
              MOVE TO DASHBOARD
            </Button>
          </div> */}
          <div className={classes.formFlexRow}>
            <div className={classes.fieldFlexColumn}>
              <label>Is Policy premium is paid in Installments</label>
              <Select
                className={classes.selectField}
                size="small"
                fullWidth
                name="isPolicyPremiumIsPaidInInstallments"
                value={
                  formPolicyDocumentDetails?.values
                    ?.isPolicyPremiumIsPaidInInstallments
                }
                onChange={(e) =>
                  formPolicyDocumentDetails.setFieldValue(
                    "isPolicyPremiumIsPaidInInstallments",
                    e.target.value,
                    true
                  )
                }
                error={
                  formPolicyDocumentDetails.touched
                    .isPolicyPremiumIsPaidInInstallments &&
                  Boolean(
                    formPolicyDocumentDetails.errors
                      .isPolicyPremiumIsPaidInInstallments
                  )
                }
              >
                {DECISION_MENUITEMS.map((item) => {
                  return <MenuItem value={item.value}>{item.title}</MenuItem>;
                })}
              </Select>
              <FormHelperText className="formikFieldsErrorColor">
                {formPolicyDocumentDetails.touched
                  .isPolicyPremiumIsPaidInInstallments &&
                  formPolicyDocumentDetails.errors
                    .isPolicyPremiumIsPaidInInstallments}
              </FormHelperText>
            </div>
            {/* <div className={classes.fieldFlexColumn}>
              <label>Is C52 id YES</label>
              <TextField
                fullWidth
                size="small"
                name="isC52IdYes"
                value={formPolicyDocumentDetails?.values?.isC52IdYes}
                onChange={formPolicyDocumentDetails.handleChange}
                helperText={
                  formPolicyDocumentDetails.touched.isC52IdYes &&
                  formPolicyDocumentDetails.errors.isC52IdYes
                }
                error={
                  formPolicyDocumentDetails.touched.isC52IdYes &&
                  Boolean(formPolicyDocumentDetails.errors.isC52IdYes)
                }
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default PolicyDocumentDetails;
